export const isDigit = (value: unknown, allowNegetives = false): boolean => {
  if (typeof value !== 'string' && typeof value !== 'number') return false;

  if (value === '') return false;
  const num = typeof value === 'string' ? Number(value) : value;

  return Number.isInteger(num) && (allowNegetives || num >= 0);
};
